import React from 'react';

import { text } from 'styles/commons/text';

/**
 * @desc INAVI Maps_상품 이용약관_START(종량제)
 * @returns
 */
const BilingPlanPremiumTerms = () => {
  return (
    <div class="content">
      <ol>
        <li>
          <strong>서비스 개요</strong>
        </li>
      </ol>
      <ul>
        <li>
          &lsquo;INAVI Maps 서비스&rsquo;란, Web과 Mobile 환경에서 지도정보를 제공하는
          위치 기반 솔루션으로, 신속한 HTTP REST API를 통해 다양한 기능을 손쉽게
          연계하고 확장할 수 있도록 설계된 Open API 플랫폼입니다.
        </li>
        <li>
          본 약관은 INAVI Maps 서비스의 특정 상품 이용에 관한 사항을 다루며, 서비스
          이용 전반에 관한 사항은 웹사이트 내 INAVI Maps 서비스 이용약관을 참고하시기
          바랍니다.
        </li>
      </ul>
      <ol start="2">
        <li>
          <strong>상품 개요</strong>
        </li>
      </ol>
      <ul>
        <li>
          &lsquo;START&rsquo; 상품은 월간 API를 호출한 사용량에 따라 후불
          청구되는 상품으로, 사용량의 월별 편차가 있는 경우와 단위 API 테스트 시
          적합한 요금제입니다.
        </li>
        <li>
          &lsquo;START&rsquo; 상품에 제공되는 단위 API, 내용 및 요금 정보는{' '}
          <text.Link href="/billing-plan" target="_blank">
            요금 소개
          </text.Link>
          를 통해 확인하실 수 있습니다.
        </li>
      </ul>
      <ol start="3">
        <li>
          <strong>기타</strong>
        </li>
      </ol>
      <ul>
        <li>
          회사는 INAVI Maps 서비스와 관련하여 회원에게 정해진 이용 조건에 따라 서비스
          이용 권한만을 부여하며, 회원은 이를 양도, 판매, 담보 제공 등의
          목적으로 처분할 수 없습니다. 본 약관에 따라 회원이 INAVI Maps 서비스를
          소유하거나 이에 대한 저작권을 가지는 것은 아니며, 단순히 회사로부터
          해당 서비스 이용 권한을 부여받는 것입니다. INAVI Maps 서비스는 정보 취득
          또는 개인적인 용도로만 제공되며, 회사의 사전 승인 없이 제3자에게
          공유하거나 판매하는 행위는 금지됩니다. 이를 위반할 경우 API 사용이
          제한될 수 있습니다.
        </li>
        <li>
          API의 정해진 파라미터 규격을 따르지 않거나 과도한 요청을 발생시켜
          시스템에 과부하를 유발하는 경우, 이는 부정 사용으로 판단될 수 있으며,
          이에 따라 서비스 이용이 제한될 수 있습니다.
        </li>
      </ul>
    </div>
  );
};

export default BilingPlanPremiumTerms;
